module.exports = __webpack_public_path__ + "img/text_havies_de_ser_en.88582174.png";